function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import * as ScanditSDK from "scandit-sdk";

import Picker from "./picker-wrapper";

var Scanner = function (_Component) {
  _inherits(Scanner, _Component);

  function Scanner() {
    var _temp, _this, _ret;

    _classCallCheck(this, Scanner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.picker = new Picker(), _this.scannerContainerRef = React.createRef(), _this.componentDidMount = function () {
      _this.configureLibrary().then(function () {
        return _this.initializePicker();
      });
    }, _this.componentWillUnmount = function () {
      if (_this.picker) {
        _this.picker.destroy();
      }
    }, _this.componentDidUpdate = function (prevProps) {
      _this.updatePicker(prevProps);
    }, _this.configureLibrary = function () {
      return ScanditSDK.configure(_this.props.licenseKey, {
        engineLocation: _this.props.engineLocation
      });
    }, _this.initializePicker = function () {
      _this.picker.initialize(_this.scannerContainerRef.current, _this.props);
    }, _this.updatePicker = function (prevProps) {
      _this.picker != null && _this.picker.update(prevProps, _this.props);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Scanner.prototype.render = function render() {
    return React.createElement("div", { ref: this.scannerContainerRef });
  };

  return Scanner;
}(Component);

Scanner.propTypes = process.env.NODE_ENV !== "production" ? {
  licenseKey: PropTypes.string.isRequired,
  engineLocation: PropTypes.string.isRequired,
  accessCamera: PropTypes.bool,
  camera: PropTypes.object,
  cameraSettings: PropTypes.object,
  enableCameraSwitcher: PropTypes.bool,
  enableTorchToggle: PropTypes.bool,
  enablePinchToZoom: PropTypes.bool,
  enableTapToFocus: PropTypes.bool,
  guiStyle: PropTypes.any,
  playSoundOnScan: PropTypes.bool,
  vibrateOnScan: PropTypes.bool,
  scanSettings: PropTypes.object,
  scanner: PropTypes.object,
  paused: PropTypes.bool,
  targetScanningFPS: PropTypes.number,
  videoFit: PropTypes.any,
  visible: PropTypes.bool,
  singleImageMode: PropTypes.object,

  onReady: PropTypes.func,
  onScannerInitialized: PropTypes.func,
  onScan: PropTypes.func,
  onScanError: PropTypes.func,
  onProcessFrame: PropTypes.func,
  onSubmitFrame: PropTypes.func
} : {};

export default Scanner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/scandit-sdk-react/es/index.js
// module id = 1379
// module chunks = 0